import App from './App.vue';
import { user } from '@/beforeGuard/defaultRules';

export default {
  path: '/CDS_VF_LoginHistoryDetail',
  name: 'CDS_VF_LoginHistoryDetail',
  component: App,
  meta: {
    pageProperty: {
      title: 'ログイン履歴',
      controller: 'CDS_CTR_LoginHistoryDetail',
    },
    guardRules: [user],
  },
};
